/* TODO: It can be bad performance, as we need to wait */
export const actions = {
  async nuxtServerInit ({ dispatch }, context) {

    if (context.$auth.user) {
      await dispatch('gpbSubscriptions/fetchNewest')
    }
  }
}
